import { useRef, useEffect, useCallback } from 'react';

const useWasRendered = () => {
  const wasRendered = useRef(false);
  useEffect(() => {
    return () => (wasRendered.current = false);
  }, []);

  const setWasRendered = useCallback(() => {
    wasRendered.current = true;
  }, []);

  const setWasUnrendered = useCallback(() => {
    wasRendered.current = false;
  }, []);

  return { wasRendered, setWasRendered, setWasUnrendered };
};

export default useWasRendered;
